// Pricing tables & helpers (AUD, ex-GST)

export const READY_MADE_SIZES = ["50 mm", "75 mm", "100 mm"];
export const READY_MADE_QTYS = [50, 100, 250, 500, 1000, 2500, 5000, 10000];

export const READY_MADE_PRICING = {
  "50 mm":   { 50: 19, 100: 29, 250: 49, 500: 89, 1000: 139, 2500: 269, 5000: 449, 10000: 799 },
  "75 mm":   { 50: 25, 100: 39, 250: 69, 500: 109, 1000: 169, 2500: 359, 5000: 674, 10000: 1299 },
  "100 mm":  { 50: 29, 100: 49, 250: 89, 500: 134, 1000: 224, 2500: 499, 5000: 899, 10000: 1699 },
};

export function readyMadePrice(size, qty) {
  return READY_MADE_PRICING[size]?.[qty] ?? null;
}

// Custom sticker pricing lives in customStickerPricing.js

export const CATEGORIES = [
  "All",
  "Shipping Labels",
  "Thank You",
  "Packaging",
  "Small Business",
  "Illawarra Local",
  "Fun & Everyday",
];

export const QUANTITY_SHOWCASE = [500, 1000, 2500, 5000, 10000, 25000, 50000, 100000];

export function formatAUD(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(n);
}



export function formatCents(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 }).format(n);
}

export function perStickerCents(total, qty) {
  if (!total || !qty) return null;
  return total / qty;
}

// Rough production time estimate for an order, based on the largest line quantity.
// Returns a human string like "3–5 business days". Shipping is separate.
export function productionEstimate(items) {
  if (!items || items.length === 0) return null;
  const maxQty = items.reduce((m, i) => Math.max(m, i.quantity || 0), 0);
  const hasCustom = items.some((i) => i.product_type === "custom");
  let low, high;
  if (maxQty <= 500) { low = 3; high = 5; }
  else if (maxQty <= 5000) { low = 5; high = 7; }
  else if (maxQty <= 25000) { low = 7; high = 10; }
  else { low = 10; high = 14; }
  if (hasCustom) { low += 1; high += 2; } // artwork review for custom
  return `${low}–${high} business days`;
}
